import { z } from "zod";

export const ERROR_CODES = [
  "bad_request",
  "validation_failed",
  "unauthorized",
  "mfa_required",
  "forbidden",
  "not_found",
  "conflict",
  "payload_too_large",
  "unsupported_protocol",
  "invite_invalid",
  "session_revoked",
  "action_closed",
  "rate_limited",
  "upstream_unavailable",
  "internal",
] as const;
export const ErrorCode = z.enum(ERROR_CODES);
export type ErrorCode = z.infer<typeof ErrorCode>;

export const ApiErrorBody = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;
